import React from 'react';
const comparisonData = [{
  name: 'Colección Lujo',
  audience: 'Compradores e inversores high-end',
  focus: 'Branding premium y exclusividad',
  integration: 'Sincronización 360° y perfiles VIP',
  idealFor: 'Propiedades en Las Mercedes, Altamira, La Lagunita'
}, {
  name: 'Tecnología de Conversión',
  audience: 'Compradores activos buscando oportunidades',
  focus: 'Captación rápida y embudo directo',
  integration: 'Alimentación directa al CRM Demand OS',
  idealFor: 'Campañas de Meta ADS y Google Ads'
}, {
  name: 'Comunidad & Estilo de Vida',
  audience: 'Familias y locales buscando arraigo',
  focus: 'Conexión emocional y posicionamiento',
  integration: 'Segmentación geográfica de leads',
  idealFor: 'Posicionamiento como expertos zonales'
}, {
  name: 'Centrado en Agentes',
  audience: 'Clientes buscando asesoría personalizada',
  focus: 'Marca personal del asesor inmobiliario',
  integration: 'Agendamiento automático y notificaciones',
  idealFor: 'Equipos de alto rendimiento y top producers'
}];
export const ComparisonTable: React.FC = () => {
  return <section id="comparativa" className="py-20 bg-white" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-remax-dark mb-4" data-id="element-52">
            Comparativa de Modelos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-53">
            Analiza las diferencias clave para elegir la estrategia perfecta
            para tu equipo.
          </p>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden shadow-lg rounded-xl border border-gray-200" data-id="element-54">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-55">
            <thead className="bg-gray-50" data-id="element-56">
              <tr data-id="element-57">
                <th scope="col" className="px-6 py-4 text-left text-sm font-bold text-gray-900 uppercase tracking-wider" data-id="element-58">
                  Nombre del Modelo
                </th>
                <th scope="col" className="px-6 py-4 text-left text-sm font-bold text-gray-900 uppercase tracking-wider" data-id="element-59">
                  Público Objetivo
                </th>
                <th scope="col" className="px-6 py-4 text-left text-sm font-bold text-gray-900 uppercase tracking-wider" data-id="element-60">
                  Enfoque Principal
                </th>
                <th scope="col" className="px-6 py-4 text-left text-sm font-bold text-gray-900 uppercase tracking-wider" data-id="element-61">
                  Integración Demand OS
                </th>
                <th scope="col" className="px-6 py-4 text-left text-sm font-bold text-gray-900 uppercase tracking-wider" data-id="element-62">
                  Ideal Para
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-63">
              {comparisonData.map((row, idx) => <tr key={idx} className="hover:bg-gray-50 transition-colors" data-id="element-64">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-remax-blue" data-id="element-65">
                    {row.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700" data-id="element-66">
                    {row.audience}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700" data-id="element-67">
                    {row.focus}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700 font-medium" data-id="element-68">
                    {row.integration}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700" data-id="element-69">
                    {row.idealFor}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Stacked Cards */}
        <div className="md:hidden space-y-6" data-id="element-70">
          {comparisonData.map((row, idx) => <div key={idx} className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 space-y-3" data-id="element-71">
              <h3 className="text-lg font-bold text-remax-blue border-b pb-2" data-id="element-72">
                {row.name}
              </h3>

              <div data-id="element-73">
                <span className="block text-xs font-bold text-gray-500 uppercase" data-id="element-74">
                  Público Objetivo
                </span>
                <span className="text-sm text-gray-800" data-id="element-75">{row.audience}</span>
              </div>

              <div data-id="element-76">
                <span className="block text-xs font-bold text-gray-500 uppercase" data-id="element-77">
                  Enfoque Principal
                </span>
                <span className="text-sm text-gray-800" data-id="element-78">{row.focus}</span>
              </div>

              <div data-id="element-79">
                <span className="block text-xs font-bold text-gray-500 uppercase" data-id="element-80">
                  Integración Demand OS
                </span>
                <span className="text-sm font-medium text-gray-800" data-id="element-81">
                  {row.integration}
                </span>
              </div>

              <div data-id="element-82">
                <span className="block text-xs font-bold text-gray-500 uppercase" data-id="element-83">
                  Ideal Para
                </span>
                <span className="text-sm text-gray-800" data-id="element-84">{row.idealFor}</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};